import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-live-multi-company/permissions',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

const permissions = []

const getPermissionsLoggedUser = () => {
    return axiosInstance.get('')
}

export { getPermissionsLoggedUser }
